export { default } from './MessengerGroupRoomFormPopUp';



// WEBPACK FOOTER //
// ./src/components/Messenger/content/MessengerGroupRoomFormPopUp/index.js